<template>
  <div>
    <div class="form-group row">
      <label :for="id" class="col-12 col-md-4 col-form-label">{{label}}</label>
      <div class="col-12 col-md-8">
        <DateSelector
          @update="UPDATE_FIELD"
          :name="name"
          :id="id"
          :errors="this.errors"
          :value="value"
          @change="UPDATE_FIELD(id, $event.target.value)"
          :maxDate="this.maxDate"
          :minDate="this.minDate"
          :enableTime="this.enableTime"
          :altDateFormat="this.altDateFormat"></DateSelector>
      </div>
      <!-- :minDate="this.dobMinDate" :maxDate="this.dobMaxDate" -->
      <div class="invalid-feedback col-12 col-md-12">Valid date is required.</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import DateSelector from "@/components/controls/DateSelector.vue";
import Tooltip from "@/components/controls/Tooltip.vue";
export default {
  name: "DatePicker",
  props: {
    label: String,
    name: String,
    id: String,
    value: {
      require: true
    },
    placeholder: String,
    readonly: Boolean,
    minDate: [String, Date],
    maxDate: [String, Date],
    yearStart: [String, Date],
    yearEnd: [String, Date],
    enableTime: { type: Boolean, default: () => false },
    altDateFormat: { type: String, default: () => "d/m/Y" },
    errors: { type: Array, default: () => [] }
  },
  components: {
    Tooltip,
    DateSelector
  },
  methods: {
    UPDATE_FIELD(key, value) {
      this.$emit("update", key, value);
    }
  }
};
</script>

<style scoped>
</style>